(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-carousel"] && !Shopify.designMode) return;
  try {
    
(function () {
  const section = document.currentScript && document.currentScript.closest('.collection-carousel') || document.querySelector('.collection-carousel[data-section-id="{{ section.id }}"]') || document.querySelector('.collection-carousel');
  if (!section) return;
  const viewport = section.querySelector('.collection-carousel__viewport');
  const track = section.querySelector('.collection-carousel__track');
  if (!viewport || !track) return;

  // settings from Liquid
  const thumbPxConfig = parseInt("{{ section.settings.thumb_size }}", 10) || 140;
  const borderStyle = "{{ section.settings.thumb_border_style }}";
  const borderColor = "{{ section.settings.thumb_border_color }}";
  const borderWidth = (parseInt("{{ section.settings.thumb_border_width }}", 10) || 1) + 'px';
  const imageShape = "{{ section.settings.image_shape }}";

  // helper: compute computed gap between items (reads CSS)
  function getGapPx() {
    try {
      const cs = window.getComputedStyle(track);
      const gap = cs.getPropertyValue('gap') || cs.getPropertyValue('grid-column-gap') || '20px';
      return parseInt(gap.replace('px',''), 10) || 20;
    } catch (e) { return 20; }
  }

  // set dimension & styles for each item/thumbnail
  function layoutThumbs(thumbPx) {
    const items = Array.from(track.children);
    items.forEach(item => {
      item.style.width = thumbPx + 'px';
      item.style.flexBasis = thumbPx + 'px';
      const thumb = item.querySelector('.collection-carousel__thumb');
      if (thumb) {
        thumb.style.width = thumbPx + 'px';
        thumb.style.height = thumbPx + 'px';
        // shape
        if (imageShape === 'rounded') {
          thumb.style.borderRadius = (thumbPx * 0.28) + 'px';
        } else if (imageShape === 'circle') {
          thumb.style.borderRadius = '999px';
        } else {
          thumb.style.borderRadius = '10px';
        }
        // border
        thumb.style.borderStyle = borderStyle;
        thumb.style.borderColor = borderColor;
        thumb.style.borderWidth = borderWidth;
      }
    });
  }

  // set side padding so first item sits centered when scrollLeft == 0
  function applySidePadding(thumbPx) {
    const viewportWidth = viewport.offsetWidth;
    // center calculation: want the first item's center to be at viewport center when scrollLeft is 0
    // sidePadding = (viewportWidth / 2) - (thumbPx / 2)
    const sidePadding = Math.max(0, Math.round((viewportWidth / 2) - (thumbPx / 2)));
    track.style.paddingLeft = sidePadding + 'px';
    track.style.paddingRight = sidePadding + 'px';
    return sidePadding;
  }

  // snap the closest item to viewport center (useful on touchend)
  function snapToClosest() {
    const items = Array.from(track.children);
    if (!items.length) return;
    const viewportWidth = viewport.offsetWidth;
    const center = viewport.scrollLeft + (viewportWidth / 2);
    let closest = items[0];
    let minDist = Infinity;
    items.forEach(it => {
      const itRect = it.getBoundingClientRect();
      // compute the item's center relative to document, but convert to scroll coordinates:
      const itemCenterOnTrack = it.offsetLeft + (it.offsetWidth / 2);
      const dist = Math.abs(itemCenterOnTrack - center);
      if (dist < minDist) {
        minDist = dist;
        closest = it;
      }
    });
    const target = closest;
    const targetScroll = Math.max(0, (target.offsetLeft + (target.offsetWidth / 2)) - (viewportWidth / 2));
    viewport.scrollTo({ left: targetScroll, behavior: 'smooth' });
  }

  // initial layout + center first item
  function init() {
    const thumbPx = thumbPxConfig;
    layoutThumbs(thumbPx);
    applySidePadding(thumbPx);
    // After padding applied, keep scrollLeft at 0 so the FIRST item will be centered.
    // Use small delay to allow layout to settle
    setTimeout(() => { viewport.scrollLeft = 0; }, 50);
  }

  // call init on load
  init();

  // Recompute on resize
  let resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      layoutThumbs(thumbPxConfig);
      applySidePadding(thumbPxConfig);
      // keep first item centered (scrollLeft 0)
      viewport.scrollLeft = 0;
    }, 120);
  });

  // Prevent image drag (fallback)
  section.querySelectorAll('img').forEach(img => {
    try {
      img.setAttribute('draggable', 'false');
      img.addEventListener('dragstart', function (e) { e.preventDefault(); }, {passive: false});
    } catch (err) {}
  });

  // Desktop drag-to-scroll (mouse)
  let isDown = false;
  let startX;
  let scrollLeft;
  viewport.addEventListener('mousedown', function (e) {
    isDown = true;
    viewport.classList.add('is-dragging');
    startX = e.pageX - viewport.offsetLeft;
    scrollLeft = viewport.scrollLeft;
    e.preventDefault();
  });
  viewport.addEventListener('mouseleave', function () {
    isDown = false;
    viewport.classList.remove('is-dragging');
  });
  viewport.addEventListener('mouseup', function () {
    isDown = false;
    viewport.classList.remove('is-dragging');
  });
  viewport.addEventListener('mousemove', function (e) {
    if (!isDown) return;
    e.preventDefault();
    const x = e.pageX - viewport.offsetLeft;
    const walk = (x - startX);
    viewport.scrollLeft = scrollLeft - walk;
  });

  // Touch: on touchend snap to closest
  viewport.addEventListener('touchend', function (ev) {
    // small timeout to allow momentum to settle before snapping
    setTimeout(snapToClosest, 80);
  }, {passive: true});

  // Keyboard nav (ArrowLeft / ArrowRight) - move by one thumb + gap
  viewport.setAttribute('tabindex', '0');
  viewport.addEventListener('keydown', function (e) {
    if (e.key === 'ArrowRight') {
      e.preventDefault();
      const gap = getGapPx();
      const next = viewport.scrollLeft + (thumbPxConfig + gap);
      viewport.scrollTo({ left: next, behavior: 'smooth' });
    } else if (e.key === 'ArrowLeft') {
      e.preventDefault();
      const gap = getGapPx();
      const prev = Math.max(0, viewport.scrollLeft - (thumbPxConfig + gap));
      viewport.scrollTo({ left: prev, behavior: 'smooth' });
    } else if (e.key === 'Home') {
      e.preventDefault();
      viewport.scrollTo({ left: 0, behavior: 'smooth' }); // first item centered
    } else if (e.key === 'End') {
      e.preventDefault();
      viewport.scrollTo({ left: track.scrollWidth, behavior: 'smooth' });
    }
  });

  // accessibility: if a user clicks a thumbnail (or focuses) prefer to center that item
  track.addEventListener('click', function (e) {
    const el = e.target.closest('.collection-carousel__item');
    if (!el) return;
    const vw = viewport.offsetWidth;
    const targetScroll = Math.max(0, (el.offsetLeft + (el.offsetWidth / 2)) - (vw / 2));
    viewport.scrollTo({ left: targetScroll, behavior: 'smooth' });
  });

  // Expose a small API on the DOM node (useful for debugging in console)
  section._collectionCarousel = {
    recenterFirst: function () { viewport.scrollLeft = 0; },
    snapToClosest: snapToClosest
  };
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
